module.exports = __webpack_public_path__ + "img/content-pic.d15d232d.png";